import { POWERBI } from "./actions";
import initialState from "../../reducers/initialState";

const PowerBiReducer = (state = initialState, action) => {
  switch (action.type) {
    //initialState
    case POWERBI.POWERBI_MODAL_TOGGLE: {
      return {
        ...state,
        powerBiView: !state.powerBiView,
      };
    }

    default:
      return state;
  }
};

export default PowerBiReducer;
